import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { RiArrowDownSLine } from 'react-icons/ri';

function Details({ children, summary, variant, ...rest }) {
  const [isOpen, toggleOpen] = useState(false);

  return (
    <div
      className={clsx(
        {
          'bg-[#FCF8E3] text-[#8A6D3B] ring-[#FAEBCC]': variant === 'warning',
          'bg-[#DF6C4F] text-white ring-[#DB3F39]': variant === 'error',
          'bg-[#DFF0D8] text-[#2C572D] ring-[#D6E9C6]': variant === 'success',
          'bg-[#C8E7EF] text-dark-gray ring-[#ACE5E7]': variant === 'info'
        },
        'text-sm ring-1'
      )}
      {...rest}
    >
      <div
        className={clsx(
          'flex cursor-pointer select-none items-center justify-between p-4 text-sm'
        )}
        onClick={() => toggleOpen(!isOpen)}
        role="button"
        tabIndex={0}
      >
        {summary}
        <RiArrowDownSLine
          className={clsx(
            { 'rotate-180': isOpen },
            'ml-4 h-4 w-4 shrink-0 transition-transform'
          )}
        />
      </div>
      <div className={clsx({ hidden: !isOpen }, 'px-4 pb-4 text-sm')}>
        <p
          className={clsx(
            {
              'text-[#8A6D3B]': variant === 'warning',
              'text-white': variant === 'error',
              'text-[#2C572D]': variant === 'success',
              'text-dark-gray': variant === 'info'
            },
            'm-0'
          )}
        >
          {children}
        </p>
      </div>
    </div>
  );
}

Details.propTypes = {
  /** Specifies the Content when the Details are expanded.  */
  children: PropTypes.node.isRequired,
  /** Specifies the Summary before the Details are expanded.  */
  summary: PropTypes.string.isRequired,
  /** Specifies the Variant of the Details.  */
  variant: PropTypes.oneOf(['warning', 'error', 'success', 'info'])
};

Details.defaultProps = {
  variant: 'info'
};

export default Details;
